<template>
  <div class="nav-bar">
    <div class="container">

<!--      <div class="left-part">-->
<!--        <router-link target="_blank" :to="{path: '/newsDetail', query: {type: 1}}">学校概况</router-link>-->
<!--        <span class="line">|</span>-->
<!--        <router-link target="_blank" :to="{path: '/newsDetail', query: {type: 2}}">学校地址</router-link>-->
<!--        <span class="line">|</span>-->
<!--        <router-link target="_blank" :to="{path: '/newsDetail', query: {type: 3}}">联系我们</router-link>-->
<!--      </div>-->
      <div class="right-part">
        <div class="parent-node">
          <router-link to="/">首页</router-link>
        </div>
        <div class="parent-node">
          <a target="_blank" href="https://www.jxvtc.edu.cn/">学校官网</a>
        </div>
        <div class="parent-node">
          <a target="_blank" href="https://www.jxvtc.edu.cn/xxzl/xxjj.htm">学校概括</a>
        </div>
        <div class="parent-node">
          <router-link target="_blank" :to="{path: '/newsList', query: {type: 'news', name: '新闻公告'}}">新闻公告</router-link>
        </div>
        <div class="parent-node">
          <router-link target="_blank" :to="{path: '/newsList', query: {type: 'edu', name: '双创教育'}}">双创教育</router-link>
          <div class="children-container">
            <div class="child" v-for="item in eduList" :key="item.dictCode">
              <router-link target="_blank" :to="{path: '/newsList', query: {typeCode: item.dictCode, name: item.dictLabel}}">{{item.dictLabel}}</router-link>
            </div>
          </div>
        </div>
        <div class="parent-node">
          <router-link target="_blank" :to="{path: '/newsList', query: {type: 'space', name: '创业空间'}}">创业空间</router-link>
          <div class="children-container">
            <div class="child" v-for="item in spaceList" :key="item.dictCode">
              <router-link target="_blank" :to="{path: '/newsList', query: {typeCode: item.dictCode, name: item.dictLabel}}">{{item.dictLabel}}</router-link>
            </div>
          </div>
        </div>
        <div class="parent-node">
          <a target="_blank" href="https://jxvtcedu.woczx.com/#/college/login">资源服务</a>
        </div>
        <div class="parent-node">
          <router-link target="_blank" :to="{path:'/newsDetail', query: {id: '1587040366502457345'}}">下载中心</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['edu', 'space'],
  data () {
    return {
      eduList: [],
      spaceList: []
    }
  },
  watch: {
    edu (n, o) {
      this.eduList = n
    },
    space (n, o) {
      this.spaceList = n
    }
  }

}
</script>

<style lang="scss" scoped>
@import '@/style/mixin.scss';
  .nav-bar {
    position: sticky;
    top: 0;
    z-index: 1001;
    height: 118px;
    background: url('../assets/nav-bg.png');
    .container {
      display: flex;
      justify-content: end;
      margin: 0 auto;
      width: $main-width;
      .left-part {
        display: flex;
        align-items: center;
        height: 20px;
        margin-top: 44px;
        color: #fff;
        font-size: 16px;
        a {
          color: #fff;
          text-decoration: none;
        }
        .line {
          margin: -2px 20px 0;
        }
      }
      .right-part {
        margin-top: 44px;
        display: flex;
        .parent-node {
          padding-bottom: 10px;
          position: relative;
          &:hover {
            .children-container {
              height: 108px;
            }
          }
          & + .parent-node {
            margin-left: 63px;
          }
          .children-container {
            height: 0;
            width: 150%;
            margin-left: -25%;
            position: absolute;
            z-index: 19;
            top: 30px;
            background: #90b0ee;
            transition: all 0.5s;
            overflow: hidden;
            border-radius: 4px;
            .child {
              height: 36px;
              line-height: 36px;
              text-align: center;
              a {
                display: block;
              }
            }
          }
        }
        a {
          font-size: 18px;
          color: #fff;
          text-decoration: none;
          &.router-link-exact-active {
            position: relative;
            &::after {
              content: '';
              position: absolute;
              height: 2px;
              width: 20px;
              left: 50%;
              bottom: -10px;
              margin-left: -10px;
              background: #fff;
            }
          }
        }
      }
    }
  }
</style>
